import React, { useContext } from 'react';

import * as mixpanel from '../../../../../../../../../../mixpanel';

import TemplatesWizardContext from '../../../TemplatesWizardContext';
import Footer from '../../Footer/Footer';

import scratchStart from '../../../../../../../../../assets/img/templateswizard/scracth_start.png';
import scratchStartSelected from '../../../../../../../../../assets/img/templateswizard/scracth_start_selected.png';
import templateStart from '../../../../../../../../../assets/img/templateswizard/template_start.png';
import templateStartSelected from '../../../../../../../../../assets/img/templateswizard/template_start_selected.png';
import uploadStart from '../../../../../../../../../assets/img/templateswizard/upload_start.png';
import uploadStartSelected from '../../../../../../../../../assets/img/templateswizard/upload_start_selected.png';

import {
  TEMPLATES_WIZARD_STEP_KEYS,
  TEMPLATES_WIZARD_START_OPTIONS
} from '../../../../../helpers/constants';

import styles from './SelectStart.module.css';
import { checkIfAllCookiesAllowed } from '../../../../../../../../../helpers/privacy';

export default () => {
  const {
    currentStep,
    setStepValue,
    goToNextStep,
    setWizardHidden,
    strings,
    surveyId,
    isAdmin
  } = useContext(TemplatesWizardContext);

  const onNextClick = () => {
    if (currentStep.value === TEMPLATES_WIZARD_START_OPTIONS.SELECT_TEMPLATE) {
      if (checkIfAllCookiesAllowed()) {
        mixpanel.actions.trackEvent(
          mixpanel.events.CLIENT_CLICK_SELECT_A_TEMPLATE,
          {
            [mixpanel.eventProperties.SURVEY_ID]: surveyId
          }
        );
      }
      return goToNextStep();
    }
    if (currentStep.value === TEMPLATES_WIZARD_START_OPTIONS.START_SCRATCH) {
      setWizardHidden(true);
      if (checkIfAllCookiesAllowed()) {
        mixpanel.actions.trackEvent(
          mixpanel.events.CLIENT_CLICK_START_FROM_SCRATCH,
          {
            [mixpanel.eventProperties.SURVEY_ID]: surveyId
          }
        );
      }
    }
    if (currentStep.value === TEMPLATES_WIZARD_START_OPTIONS.UPLOAD_FILE) {
      return goToNextStep();
    }
    return null;
  };

  const checkIsActive = valueToCheck =>
    currentStep && currentStep.value === valueToCheck;

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {strings.HOW_MUCH_WOULD_YOU_LIKE_TO_BUILD_YOUR_SURVEY}
      </div>
      <div className={styles.subTitle}>{strings.CHOOSE_STARTING_POINT}</div>
      <div className={styles.optionsContainer}>
        <div
          className={
            checkIsActive(TEMPLATES_WIZARD_START_OPTIONS.SELECT_TEMPLATE)
              ? `${styles.option} ${styles.selectedOption}`
              : styles.option
          }
          onClick={() =>
            setStepValue(
              TEMPLATES_WIZARD_STEP_KEYS.SELECT_START,
              TEMPLATES_WIZARD_START_OPTIONS.SELECT_TEMPLATE
            )
          }
          role="presentation"
        >
          <img
            src={
              checkIsActive(TEMPLATES_WIZARD_START_OPTIONS.SELECT_TEMPLATE)
                ? templateStartSelected
                : templateStart
            }
            alt="Select a template"
          />
          <div className={styles.optionLabel}>{strings.SELECT_TEMPLATE}</div>
          {checkIsActive(TEMPLATES_WIZARD_START_OPTIONS.SELECT_TEMPLATE) && (
            <div className={styles.selectedBar} />
          )}
        </div>
        {isAdmin ? (
          <div
            className={
              checkIsActive(TEMPLATES_WIZARD_START_OPTIONS.UPLOAD_FILE)
                ? `${styles.option} ${styles.selectedOption}`
                : styles.option
            }
            onClick={() =>
              setStepValue(
                TEMPLATES_WIZARD_STEP_KEYS.SELECT_START,
                TEMPLATES_WIZARD_START_OPTIONS.UPLOAD_FILE
              )
            }
            role="presentation"
          >
            <span className={styles.betaLabel}>BETA</span>
            <img
              src={
                checkIsActive(TEMPLATES_WIZARD_START_OPTIONS.UPLOAD_FILE)
                  ? uploadStartSelected
                  : uploadStart
              }
              alt="AI clipart"
            />
            <div className={styles.optionLabel}>
              {strings.UPLOAD_A_DOCUMENT}
            </div>
            {checkIsActive(TEMPLATES_WIZARD_START_OPTIONS.UPLOAD_FILE) && (
              <div className={styles.selectedBar} />
            )}
          </div>
        ) : null}
        <div
          className={
            checkIsActive(TEMPLATES_WIZARD_START_OPTIONS.START_SCRATCH)
              ? `${styles.option} ${styles.selectedOption}`
              : styles.option
          }
          onClick={() =>
            setStepValue(
              TEMPLATES_WIZARD_STEP_KEYS.SELECT_START,
              TEMPLATES_WIZARD_START_OPTIONS.START_SCRATCH
            )
          }
          role="presentation"
        >
          <img
            src={
              checkIsActive(TEMPLATES_WIZARD_START_OPTIONS.START_SCRATCH)
                ? scratchStartSelected
                : scratchStart
            }
            alt="Start from scratch"
          />
          <div className={styles.optionLabel}>{strings.START_FROM_SCRATCH}</div>
          {checkIsActive(TEMPLATES_WIZARD_START_OPTIONS.START_SCRATCH) && (
            <div className={styles.selectedBar} />
          )}
        </div>
      </div>
      <div className={styles.footerContainer}>
        <Footer
          hiddenPrevious
          onNextClick={onNextClick}
          nextLabel={strings.NEXT}
          previousLabel={strings.PREVIOUS}
        />
      </div>
    </div>
  );
};
